const CALLBACK_FN_NAME = 'mapAPIReady'

let mapAPICount = 0

const mapAPILoadStatus = {}

const resolves = []

const createScript = (mapAPISrc, globalAPIKey, callbackFnName) => {
  let script = document.createElement('script')
  let removeScript = () => {
    document.body.removeChild(script)
    removeScript = script = null
  }

  script.type = 'text/javascript'
  script.src = `${mapAPISrc}&callback=${callbackFnName}`
  script.onload = removeScript
  script.onerror = () => {
    createScript(mapAPISrc, globalAPIKey, callbackFnName)
    removeScript()
  }

  document.body.appendChild(script)

  mapAPILoadStatus[mapAPISrc] = 1
}

const loadMapAPI = (mapAPISrc, globalAPIKey, resolve) => {
  let callbackFnName = `${CALLBACK_FN_NAME}${mapAPICount++}`
  resolves.push(resolve)

  window[callbackFnName] = () => {
    delete window[callbackFnName]
    let MapAPI = window[globalAPIKey]

    for (; resolves.length > 0;) {
      let resolve = resolves.shift()
      resolve(MapAPI)
    }
  }

  createScript(mapAPISrc, globalAPIKey, callbackFnName)
}

export default (mapAPISrc, globalAPIKey) => new Promise(resolve => {
  let MapAPI = window[globalAPIKey]
  MapAPI ? resolve(MapAPI) : mapAPILoadStatus[mapAPISrc] === 1 ? resolves.push(resolve) : loadMapAPI(mapAPISrc, globalAPIKey, resolve)
})



// WEBPACK FOOTER //
// ./src/components/Map/mapAPILoader.js